import { sortArray } from '@/utils/handleData.js'
import {
  isLockedOrgRole,
  isSuperAdminFromRoot,
  isSystemAdminRoleCode,
  LOCKED_ROLE_BUTTONS,
  pickOrgAdminRole
} from '@/utils/roleLock'
import { pageTreeHasSalaryPayment } from '@/utils/laborExitSalaryGate.js'

const sortOrgWebPages = (pages) =>
  sortArray(pages || [], ['index', 'pageName'], ['number'])
const sortOrgAppletPages = (pages) =>
  sortArray(pages || [], ['pageIndex', 'sort', 'index', 'pageName'], [
    'number',
    'number',
    'number'
  ])

export default {
  namespaced: true,
  state: {
    sysRoles: [], // 系统用户角色字典表
    orgRoles: [], // 机构角色模板所有角色
    webDefaultPages: [], // 某角色web端默认权限页面
    appletDefaultPages: [], // 某角色小程序端默认权限页面
    orgAdminWebRoles: [], // 机构系统管理员拥有的角色权限页面
    orgAdminAppletRoles: [],
    parentScopeWebRoles: [],
    parentScopeAppletRoles: []
  },
  getters: {},
  actions: {
    // 获取系统用户角色字典表
    async getSysRoles({ commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/role/info',
          data: { fields: 'roleName,roleCode,uid,isChange,isInit,orgType' }
        },
        { root: true }
      )
      // console.log(res)
      if (res.data) {
        res.data.forEach((item) => {
          if (item.isChange === '1') {
            item.isEdit = '是'
          } else {
            item.isEdit = '否'
          }
          if (item.isInit === '1') {
            item.isPreset = '是'
          } else {
            item.isPreset = '否'
          }
        })
        commit(
          'baseSet',
          { module: 'role', key: 'sysRoles', value: res.data },
          { root: true }
        )
        return res.data
      }
    },
    // 新增系统用户角色
    async addSysRole({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/role/info',
          data: data,
          msg: '新增系统角色成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑系统用户角色
    async editSysRole({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/rule/role/info',
          data: data,
          msg: '编辑系统角色成功'
        },
        { root: true }
      )
      return res
    },
    // 删除系统用户角色
    async deleteSysRole({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/rule/role/info',
          data: { uid: uid },
          msg: '删除系统角色成功'
        },
        { root: true }
      )
      return res
    },
    // 获取机构用户角色模板
    async getOrgAllRoles({ rootState, rootGetters, commit, dispatch }, uid) {
      var organizeUid = uid
      const managingChildren =
        rootState.currentTab && rootState.currentTab.label === '下级角色'
      const superOrgRole =
        rootGetters['user/orgName'] === '甘肃大鹏鸟科技有限公司' &&
        rootState.currentTab &&
        rootState.currentTab.label === '机构角色'
      if (!organizeUid) {
        organizeUid =
          superOrgRole || managingChildren
            ? rootState.activeNav
            : rootState.user.orgValue
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/jurisdiction/orgrole',
          data: { organizeUid: organizeUid }
        },
        { root: true }
      )
      var orgRoles = res.data ? res.data : []
      var isSuperAdmin = isSuperAdminFromRoot(rootState)
      orgRoles.forEach((item) => {
        item.id = item.uid
        item.label = item.roleName
        item.isEdit = item.isChange === '1' || item.isChange === 1 ? '是' : '否'
        item.disabledButtons = []
        if (!isSuperAdmin && !managingChildren && isLockedOrgRole(item)) {
          item.disabledButtons = LOCKED_ROLE_BUTTONS.slice()
        }
      })
      var adminRole = pickOrgAdminRole(orgRoles)
      var adminRoleUid = adminRole ? adminRole.uid : ''
      commit(
        'baseSet',
        { module: 'role', key: 'orgRoles', value: orgRoles },
        { root: true }
      )
      if (adminRoleUid) {
        const orgAdminWebRoles = await dispatch('getOrgRoleWebDefault', {
          roleUid: adminRoleUid,
          orgUid: organizeUid
        })
        commit(
          'baseSet',
          {
            module: 'role',
            key: 'orgAdminWebRoles',
            value: sortOrgWebPages(orgAdminWebRoles)
          },
          { root: true }
        )
        const orgAdminAppletRoles = await dispatch('getOrgRoleAppletDefault', {
          roleUid: adminRoleUid,
          orgUid: organizeUid
        })
        commit(
          'baseSet',
          {
            module: 'role',
            key: 'orgAdminAppletRoles',
            value: sortOrgAppletPages(orgAdminAppletRoles)
          },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'role', key: 'orgAdminWebRoles', value: [] },
          { root: true }
        )
        commit(
          'baseSet',
          { module: 'role', key: 'orgAdminAppletRoles', value: [] },
          { root: true }
        )
      }
      return orgRoles
    },
    async loadParentScopePages({ rootState, dispatch, commit }, roleCode) {
      const orgUid = rootState.user && rootState.user.orgValue
      if (!orgUid) {
        commit('baseSet', { module: 'role', key: 'parentScopeWebRoles', value: [] }, { root: true })
        commit('baseSet', { module: 'role', key: 'parentScopeAppletRoles', value: [] }, { root: true })
        return
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/jurisdiction/orgrole',
          data: { organizeUid: orgUid }
        },
        { root: true }
      )
      const list = res.data ? res.data : []
      const matchedByCode = list.find((item) => item && item.roleCode === roleCode)
      const ownAdmin = pickOrgAdminRole(list)
      const candidates = []
      if (matchedByCode) candidates.push(matchedByCode)
      if (ownAdmin && (!matchedByCode || ownAdmin.uid !== matchedByCode.uid)) {
        candidates.push(ownAdmin)
      }
      if (!candidates.length) {
        commit('baseSet', { module: 'role', key: 'parentScopeWebRoles', value: [] }, { root: true })
        commit('baseSet', { module: 'role', key: 'parentScopeAppletRoles', value: [] }, { root: true })
        return
      }
      let webPages = []
      let appletPages = []
      for (let i = 0; i < candidates.length; i++) {
        const item = candidates[i]
        const webRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/rule/role/weborgpage',
            data: { roleUid: item.uid, orgUid }
          },
          { root: true }
        )
        const appletRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/rule/page/wxrole',
            data: { roleUid: item.uid, orgUid }
          },
          { root: true }
        )
        if (!webPages.length && webRes.data && webRes.data.length) {
          webPages = webRes.data
        }
        if (!appletPages.length && appletRes.data && appletRes.data.length) {
          appletPages = appletRes.data
        }
        if (webPages.length && appletPages.length) break
      }
      commit('baseSet', { module: 'role', key: 'parentScopeWebRoles', value: sortOrgWebPages(webPages) }, { root: true })
      commit('baseSet', { module: 'role', key: 'parentScopeAppletRoles', value: sortOrgAppletPages(appletPages) }, { root: true })
    },
    // 新增机构用户角色
    async addOrgSysRole({ dispatch, rootState }, data) {
      const payload = Object.assign({}, data)
      const managingChildren =
        rootState.currentTab && rootState.currentTab.label === '下级角色'
      if (!payload.orgUid) {
        payload.orgUid = managingChildren
          ? rootState.activeNav
          : rootState.user.orgValue
      }
      if (!isSuperAdminFromRoot(rootState)) {
        payload.isChange = isSystemAdminRoleCode(payload.roleCode)
          ? '0'
          : '1'
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/org/role',
          data: payload,
          msg: '新增机构角色成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑机构用户角色
    async editOrgSysRole({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/rule/org/role',
          data: data,
          msg: '编辑机构角色成功'
        },
        { root: true }
      )
      return res
    },
    // 删除机构用户角色
    async deleteOrgSysRole({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/rule/org/role',
          data: { uid: uid },
          msg: '删除机构角色成功'
        },
        { root: true }
      )
      return res
    },
    // 超管：将系统预设角色同步到机构
    async syncPresetOrgRoles({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/org/role/syncPreset',
          data: data,
          msg: '同步预设角色成功'
        },
        { root: true }
      )
      return res
    },
    // 获取系统角色web端默认配置页面
    async getSysRoleWebDefault({ commit, dispatch }, roleUid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/role/webpage',
          data: { roleUid: roleUid }
        },
        { root: true }
      )
      // console.log(res)
      var webDefaultPages = res.data && res.data.pages ? res.data.pages : []
      commit(
        'baseSet',
        { module: 'role', key: 'webDefaultPages', value: webDefaultPages },
        { root: true }
      )
      return webDefaultPages
    },
    // 配置系统角色web端页面
    async setSysRoleWebRights({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/role/webpage',
          data: data,
          msg: '角色web端权限配置成功'
        },
        { root: true }
      )
      return res
    },
    // 获取机构角色web端默认配置页面
    async getOrgRoleWebDefault({ commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/role/weborgpage',
          data: { roleUid: data.roleUid, orgUid: data.orgUid }
        },
        { root: true }
      )
      // console.log(res)
      commit(
        'baseSet',
        {
          module: 'role',
          key: 'webDefaultPages',
          value: res.data ? res.data : []
        },
        { root: true }
      )
      return res.data ? res.data : []
    },
    /**
     * 判断劳务公司 labor_admin 是否拥有薪酬统计模块权限。
     * 查询失败时默认 true（走完整退场确认流程，避免误跳过薪酬环节）。
     */
    async laborAdminHasSalaryPayment({ dispatch }, laborTeamUid) {
      const orgUid = laborTeamUid ? String(laborTeamUid).trim() : ''
      if (!orgUid) return true
      try {
        const roleRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/query/jurisdiction/orgrole',
            data: { organizeUid: orgUid },
            noErrorMsg: true
          },
          { root: true }
        )
        const roles = roleRes && roleRes.data ? roleRes.data : []
        const laborAdmin = (roles || []).find(
          (item) => item && item.roleCode === 'labor_admin'
        )
        if (!laborAdmin || !laborAdmin.uid) return false
        // 直接查页面，避免写回 webDefaultPages 干扰权限配置页
        const pageRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/rule/role/weborgpage',
            data: { roleUid: laborAdmin.uid, orgUid },
            noErrorMsg: true
          },
          { root: true }
        )
        return pageTreeHasSalaryPayment(pageRes && pageRes.data ? pageRes.data : [])
      } catch (e) {
        return true
      }
    },
    // 配置机构角色web端页面
    async setOrgRoleWebRights({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/role/weborgpage',
          data: data,
          msg: '角色web端权限配置成功'
        },
        { root: true }
      )
      return res
    },
    // 获取系统角色Applet端默认配置页面
    async getSysRoleAppletDefault({ commit, dispatch }, roleUid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/page/wxtemplaterole',
          data: { roleUid: roleUid }
        },
        { root: true }
      )
      // console.log(res)
      var appletDefaultPages = res.data ? res.data : []
      commit(
        'baseSet',
        {
          module: 'role',
          key: 'appletDefaultPages',
          value: appletDefaultPages
        },
        { root: true }
      )
      return appletDefaultPages
    },
    // 配置系统角色Applet端页面
    async setSysRoleAppletRights({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/page/wxtemplaterole',
          data: data,
          msg: '角色Applet端权限配置成功'
        },
        { root: true }
      )
      return res
    },
    // 获取机构角色Applet端默认配置页面
    async getOrgRoleAppletDefault({ commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/page/wxrole',
          data: { roleUid: data.roleUid, orgUid: data.orgUid }
        },
        { root: true }
      )
      // console.log(res)
      commit(
        'baseSet',
        {
          module: 'role',
          key: 'appletDefaultPages',
          value: res.data ? res.data : []
        },
        { root: true }
      )
      return res.data ? res.data : []
    },
    // 配置机构角色Applet端页面
    async setOrgRoleAppletRights({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/page/wxrole',
          data: data,
          msg: '角色Applet端权限配置成功'
        },
        { root: true }
      )
      return res
    }
  }
}
